import { i18n } from "@/setup/i18n-setup";
import { TranslateResult } from "vue-i18n";
import { Model } from "./model";
import { IModel } from "./model-interface";
import { NamedFilter } from "./named-filter";
import { HumanFilter } from "../human-filter";

export class ProductSupplierNamedFilter extends NamedFilter {
	public fieldName:string = "";

	public constructor(data:{name:string, filterToString:(filter:HumanFilter)=>TranslateResult, fieldName:string, canBeUsedAsViewFilter?:boolean}){
		super(data);
		this.fieldName = data.fieldName;
		this.canBeUsedAsDefaultViewFilter = data.canBeUsedAsViewFilter || false;
	}

	public getFilterEditComponentName(model: Model): string {
		return "product-supplier-field";
	}

	public getDisplayName(model:IModel):TranslateResult {
		return i18n.t(`models.friendlyNames.Product.namedFilterHasSupplierWithField`, {field: i18n.t(`models.friendlyNames.ProductSupplier.${this.fieldName}`)});
	}
}